import React from 'react';
import { connect } from 'react-redux';
import { Switch, Route, withRouter, Redirect, Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import _ from 'lodash';

import SideScrollingTab from 'modules/common/components/SideScrollingTab';
import { CSVUploadContent } from './content'

import * as c from './constants'

function CSVUploadContainer({
  pathName,
  match,
}) {
  
  return (
    <>
      <div className="card-content-listing">
        <div className="container-fluid">
          <h2 className="font-weight-bold">
            CSV Upload
          </h2>
          <div className="row">
            <SideScrollingTab dragToScroll hideScrollButtons>
              <ul className="nav nav-tabs btn-settings-tab-container">
                {c.CSV_UPLOAD_MENU?.map((item) => (
                  <li key={item.path} className="nav-item">
                    <Link
                      to={_.get(item, "path")}
                      className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                        pathName.indexOf(_.get(item, "path")) > -1
                          ? 'selected'
                          : ''
                      }`}
                    >
                      {_.get(item, "name")}
                    </Link>
                  </li>
                ))}
              </ul>
            </SideScrollingTab>
          </div>
        </div>
        <Switch>
          <Route
            exact
            path={`${match.path}`}
            render={() => <Redirect to={`${match.path}/address`} />}
          />
          {c.CSV_UPLOAD_MENU?.map((item) => {
            return (
              <Route
                key={item.path}
                exact
                path={`${match.path}/${item.path}`}
                component={item.component}
                render={() => <CSVUploadContent CSV_NAME={item.csv_name} title={item.name} />}
              />
            )
          })}
        </Switch>
      </div>
    </>
  )
}

CSVUploadContainer.defaultProps = {
  pathName: '',
}

CSVUploadContainer.propTypes = {
  pathName: PropTypes.string,
  match: PropTypes.instanceOf(Object).isRequired,
}

const mapStateToProps = ({ location }) => ({
  pathName: _.get(location, 'pathname'),
})

const enhance = _.flowRight([withRouter, connect(mapStateToProps)])

export default enhance(CSVUploadContainer);
